import { ArrowUpRight, MapPin } from "lucide-react";
import Reveal from "@/components/Reveal";
import { serviceAreas } from "@/data/siteData";

export default function AreasSection({ onQuote }) {
  return (
    <section className="areas-section" id="areas" data-testid="service-areas-section">
      <div className="section-shell areas-layout">
        <Reveal className="areas-intro" delay={70}>
          <div className="eyebrow eyebrow--dark"><span className="eyebrow__dot" /> 05 / Service areas</div>
          <h2>Island-wide.<br /><em>By appointment.</em></h2>
          <p>From the marina to the hillside, our crews move with the rhythm of Sint Maarten and arrive ready to raise the standard.</p>
          <button className="button button--dark" type="button" onClick={() => onQuote()} data-testid="areas-quote-button">Tell us where <ArrowUpRight size={17} /></button>
        </Reveal>
        <div className="areas-list">
          {serviceAreas.map((area, index) => <Reveal as="div" className="area-item" delay={130 + index * 55} key={area} data-testid={`service-area-${index + 1}`}><span>{String(index + 1).padStart(2, "0")}</span><MapPin size={15} /><strong>{area}</strong></Reveal>)}
        </div>
      </div>
    </section>
  );
}
